import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { ChartDataset, TooltipCallbacks } from 'chart.js';
import { _DeepPartialObject } from 'chart.js/dist/types/utils';
import { isSameDay } from 'date-fns';
import { Anlegg, Verdi } from 'src/app/services/forbruk/forbruk.types';
import {
  labelTooltipCallback,
  titleTooltipCallback
} from '../../forbruk-charts-utils';
import { hasChanged } from 'src/app/utils/change-utils';

@Component({
  selector: 'app-hour-chart-usage',
  templateUrl: './hour-chart-usage.component.html',
  styleUrls: ['./hour-chart-usage.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HourChartUsageComponent implements OnInit, OnChanges {
  @Input() valgtAnlegg: Anlegg;
  @Input() selectedDate: Date;

  dataSets: ChartDataset<'bar'>[];
  labels: Date[];
  title: string;
  tooltipCallbacks: _DeepPartialObject<TooltipCallbacks<'bar'>>;
  useCurrentDay = false;
  showLegend = false;

  constructor() {}

  ngOnInit(): void {
    if (this.valgtAnlegg && this.selectedDate) {
      this.getChartData();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.valgtAnlegg &&
      this.selectedDate &&
      changes.valgtAnlegg &&
      hasChanged([changes?.valgtAnlegg])
    ) {
      this.getChartData();
    }
  }

  getChartData() {
    this.dataSets = [];

    // Plusskunde produksjon
    const proddata = [];
    let plusskundedataFound = false;

    this.title = 'Strømforbruk';
    this.tooltipCallbacks = {
      label: (tt) => labelTooltipCallback(tt, 'kWh'),
      title: (tt) =>
        titleTooltipCallback(tt, 'hour', 'kWh', 'forbruk_tooltip_chart1')
    };

    const data = this.valgtAnlegg.verdiList.map((value: Verdi) => {
      // Safari 12 er sær på hvilket format Date konstruktøren tar imot
      // Så vi må trikse litt med tidspunktene for å få riktig tidssone
      const [dateS, timeS] = value.tidspunkt.split('T');
      const valueHour = Number(timeS.slice(0, 2));
      const valueDate = new Date(dateS);
      valueDate.setHours(valueHour);

      if (isSameDay(valueDate, this.selectedDate)) {
        this.useCurrentDay = true;

        if (this.valgtAnlegg.plusskunde) {
          proddata.push(value.plussverdi || 0);
          if (value.plussverdi > 0) {
            plusskundedataFound = true;
          }
        }
        return { label: valueDate, value: value.verdi || 0 };
      }
    });

    this.labels = data.map((x) => {
      return x?.label;
    });
    this.showLegend = plusskundedataFound;

    if (this.useCurrentDay) {
      this.dataSets.push({
        data: data.map((x) => x?.value || 0),
        label: 'Forbruk',
        backgroundColor: '#002987',
        order: 1
      });
      if (plusskundedataFound) {
        this.dataSets.push({
          data: proddata,
          label: 'Overskudd',
          backgroundColor: '#26b41b',
          order: 2
        });
      }
    }
  }
}
